import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";

import UserRoles from "constants/UserRoles";
import moment from "moment";
import ScheduleHeader from "../../../../../components/Parts/ScheduleHeader";


const breadcrumbsStatic = [{
	name: 'Hiring',
	url: '/hiring/heatmap',
	icon: 'ticket',
}];

export default class HiringSchedules extends Framework.Components.View {

	constructor(props) {
		super(props);
		this.state.currentView = 'day';
		this.state.currentDay = moment().format('dddd');
		this.state.filterWeek = moment().day(0).format('YYYY-MM-DD');
	}

	render() {
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: 'Schedules',
				url: '/hiring/hiringschedules',
				icon: 'ticket',
			}
		]);
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}>
					<div style={{width: "65vw"}}>
						<ScheduleHeader parent={this} roles={this.props.roles} type={"Hiring"}/>
					</div>
				</Framework.Components.PageBar>
				<Collections.SchedulesComponent
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					filterWeek={this.state.filterWeek}
					currentView={this.state.currentView}
					currentDay={this.state.currentDay}
					override={"GET_HIRING"}
					roles={this.props.roles}
					key={this.state.key}
				/>
			</div>
		);
	}
}


